import { gql } from '@apollo/client';

export const STAFF_USER_DETAILS = gql`
  query StaffUserDetails($input: StaffUserDetailsInput!) {
    staffUserDetails(input: $input) {
      user {
        uuid
        accessToken
        activeProductSlug
        email
        isoCountry
        isoRegion
        lat
        lng
        nickname
        organization {
          uuid
          name
        }
        passwordModifiedAt
        passwordResetExpiresAt
        passwordResetToken
        promo
        referralCode
        remoteAddr
        source
        stripeCustomerId
        termsAt
        userAgent
        subscriptions {
          uuid
          status
          expiresAt
          product {
            uuid
            name
            slug
          }
          userUuid
        }
      }
    }
  }
`;
